import Header from './../../../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../../../ProgressHUD/index.vue'
import { VueEditor } from 'vue2-editor'
import { Api, Toast } from './../../../../services'
import WidgetTermsOfUse from './../../Widget/TermsOfUse.vue'

export default {
  name: 'ProductAdd',
  props: [],
  components: {
    Header,
    ProgressHUD,
    VueEditor,
    WidgetTermsOfUse
  },
  data() {
    return {
      product: {
        name: '',
        description: '',
        price: '',
        type: 'Product',
        details: { 
          dimensions: '',
          number: '', // Item Model Number
          weight: '', // itemWeight
          shipping: '', // shippingWeight
          manufacture: '',
          asin: '',
        },
        specs: '',
        available: '', // Count available
        images: null,
        country: '',
        region: '',
        percentGreen: 0,
        walletAddressBTC: '',
        walletAddressETH: '',
        payMethods: '',
        draft: false,
        height: "",
        width: "",
        depth: "",
      },
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ],
      isAcceptTerms: false,
      isOpenModalOnlyTerms: false,
      validationMessage: '',
      percents: [{"value": 10},{"value": 15}, {"value": 20}],
      payMethods: [{"name": "payment BTC", "value": "btc" }, {"name": "payment ETH", "value": "eth"}, {"name": "Credit Card", "value":"cc"}, {"name": "PayPal", "value": "pp"}],
      height: "",
      width: "",
      depth: "",
      draft: false,
    }
  },
   computed: {
    isWalletAddressETH() {
      // check if walletAddress is empty
      if (this.product.walletAddressBTC === '') return true // walletAddressETH is required
      return false
    },
    isWalletAddressBTC() {
      // check if walletAddressETH is empty
      if (this.product.walletAddressETH === '') return true // walletAddress is required
      return false
    },
  },
  methods: {
    setHeightImage() {
      var pic_box = $('.picture-box')
      if (pic_box && pic_box[0]) {
        var h = document.getElementById('content').clientHeight
        pic_box[0].style.height =
          (h > screen.availHeight ? h - 80 : screen.availHeight - 80) + 'px'
      }
    },

    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize(event) {
      this.setHeightImage()
    },

    saveDraftProduct() {      
      this.draft = true;
      this.saveProduct();
    },

    async saveProduct() {   
      try {
        if ( ! this.draft){
          console.log(" ! draft")
          let isValid = await this.$validator.validateAll('firstForm')
          if (
            !isValid ||
            !this.editorIsNotEmpty(this.product.description) ||
            !this.editorIsNotEmpty(this.product.specs)
          ) {
            Toast.validationFieldsError({ toast: this.$toast })
            return
          }
        }
        else {
           console.log(" draft")
          if (this.product.name == "") {
            Toast.validationFieldsError({ toast: this.$toast })
          }
        }

        // if (this.isAcceptTerms == false) {
        //     $('#modalTermsAndConditions').modal('open')
        //     return
        // }

        console.log("draft>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
        console.log(this.draft)
        this.product.draft = this.draft  

        this.$refs.progress.show()

        this.product.country = (this.$refs.selectCountry.value) ? this.$refs.selectCountry.value : ""
        this.product.percentGreen = (this.$refs.selectPercent.value) ? this.$refs.selectPercent.value : 10
        this.product.details.dimensions = (this.height || this.width || this.depth) ? this.height + "x" + this.width + "x" + this.depth : ""

        console.log("this.product *******************")
        console.log(this.product)

        var formData = new FormData()
        for (var key in this.product) {
          if (String(key) == 'details' || String(key) == 'images') break

          formData.append(key, this.product[key])
        }

        // Append images to formData
        if(! this.draft)        
          for (
            var index = 0;
            !(!(index < this.product.images.length) || !(index < 5)); // Upload 5 images or less
            index++
          ) {
            formData.append('files' + index, this.product.images[index])
          }

        if (this.product.details) formData.append('details', String(JSON.stringify(this.product.details)))
        if (this.product.specs) formData.append('specs', this.product.specs)
        if (this.product.available) formData.append('available', this.product.available)
        if (this.product.country) formData.append('country', this.product.country)
        if (this.product.percentGreen) formData.append('percentGreen', this.product.percentGreen)
        if (this.product.region) formData.append('region', this.product.region)
        if (this.product.payMethods) formData.append('payMethods', this.product.payMethods)

        formData.append('draft', this.product.draft)

        var response = await Api.createProduct(formData)
     
        this.$router.push('/product/' + response.data.product._id)
      } catch (error) {
        console.error(error)
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {
        console.log("tutu>>>>>>>>>>>>>>>>>>>>>>")
        this.$refs.progress.hide()
      }
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      this.product.images = files

      if (this.product.images.length >= 5) {
        this.$toast.error({
          title: 'Error',
          message: 'You can upload up to five images',
          color: '#BD362F',
        })
      }
    },

    editorIsNotEmpty: function(html) {
      if (this.strip(html) == '') {
        return false
      }

      return true
    },

    strip: function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html')
      return doc.body.textContent || ''
    },

    acceptTerms() {
      this.isAcceptTerms = true

      if (this.isOpenModalOnlyTerms == false) {
        this.saveProduct()
      }
    },

    notAcceptTerms() {
      this.isAcceptTerms = false
    },
  },
  created() {
    this.countries = require('./../../../../data/country.js')
  },
  mounted() {
    var _s = this
    this.$refs.selectCountry.onchange = function(){ 
      _s.product.country = this.value;
    }
    this.$refs.selectPayment.onchange = function(el){ 
      var selectedPay = [];
      for (let i = 0; i < 5; i++) 
        if (this[i].selected === true && !i==0) 
          selectedPay.push(this[i].value);        
          
      _s.product.payMethods = selectedPay;      
    }

    this.setHeightImage()


    $('.modal').modal({
      dismissible: true,
      opacity: 0.5,
      inDuration: 300,
      outDuration: 200,
      startingTop: '4%',
      endingTop: '10%',
      ready: function(modal, trigger) {},
      complete: function() {
        this.isOpenModalOnlyTerms = false
      },
    })


    this.setHeightImage()

    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Product/Add/ProductAdd.component.js